<template>
  <v-app>
    <v-main>
      <DemoLayout/>
      <Footer/>
    </v-main>
  </v-app>
</template>

<script>  
import DemoLayout from '@/components/layouts/DemoLayout.vue'
import Footer from '@/components/subcomponents/Footer.vue'

export default {
  name: 'App',
  components: {
    DemoLayout,
    Footer
  }
}
</script>

<style>

#app {
  font-family: ProximaNova !important;
}

@font-face {
   font-family: ProximaNova;
   src: url("../assets/fonts/ProximaNova-Regular.otf") format("opentype");
}

/* width */
::-webkit-scrollbar {
  width: 1.3vh;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgba(122,153,177,0.1);
  border-radius: 7px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background:rgba(122,153,177,1);
  border-radius: 7px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(122,153,177,1);
}

</style>
